import type { Order } from '../types';

/** True when this order should affect opening-quantity / sold math for the given event profile. */
export function orderMatchesEventProfile(order: Order, profileId: string | null | undefined): boolean {
  if (!profileId) return true;
  const oid = String(order.eventMenuSnapshotId ?? order.eventId ?? '').trim();
  if (!oid) return false;
  return oid === String(profileId);
}
